"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var sok_ui_1 = require("@caddigital/sok-ui");
var tenderActions = require("@caddigital/sok-reducers/lib/actions/bid/tender");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var fileListFilter_1 = require("utils/helpers/fileListFilter");
var FileList_1 = require("views/FileListOverview/FileList");
var ListHeader_1 = require("./components/ListHeader");
var ListRow_1 = require("./components/ListRow");
var utils_1 = require("./utils");
var dispatch_1 = require("./components/utils/dispatch");
var mapTenderDispatch = require("../utils");
var EmptyContent_1 = require("./components/EmptyContent");
var RevisionModal_1 = require("../RevisionModal");
var Banner_1 = require("./components/Banner");
var utils_2 = require("../utils");
var useStatusEffect_1 = require("./hook/useStatusEffect");
var SpinnerButton_1 = require("components/SpinnerButton");
var ReliablePartner = function (props) {
    var _a = (0, react_redux_1.useSelector)(function (state) { return ({
        isMobile: state.viewport.size !== 'DESKTOP',
        root: state.bid.tender.documents.reliablePartnerRoot,
        documents: state.bid.tender.documents.reliablePartner,
        selectedDocuments: state.bid.tender.documents.selectedDocuments,
        currentUser: state.auth.current,
        reliablePartnerStatusCheck: state.bid.tender.reliablePartnerStatusCheck,
        reliablePartnerReportStatus: state.bid.tender.reliablePartnerReportFetchStatus.reportStatus,
        reportParticipantUuid: state.bid.tender.reliablePartnerReportFetchStatus.participantUuid,
        reliablePartnerStatusFailure: state.bid.tender.reliablePartnerStatusUpdateFailure,
        reliablePartnerFetchStatus: state.bid.tender.documents.reliablePartnerFetchStatus
    }); }), isMobile = _a.isMobile, root = _a.root, documents = _a.documents, selectedDocuments = _a.selectedDocuments, currentUser = _a.currentUser, reliablePartnerStatusCheck = _a.reliablePartnerStatusCheck, reliablePartnerReportStatus = _a.reliablePartnerReportStatus, reportParticipantUuid = _a.reportParticipantUuid, reliablePartnerStatusFailure = _a.reliablePartnerStatusFailure, reliablePartnerFetchStatus = _a.reliablePartnerFetchStatus;
    var dispatchers = (0, dispatch_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var tenderActionsDispatch = mapTenderDispatch.mapDispatchers((0, react_redux_1.useDispatch)());
    var _b = React.useState([]), items = _b[0], setItems = _b[1];
    var _c = React.useState([]), columns = _c[0], setColumns = _c[1];
    var _d = React.useState(false), allSelected = _d[0], setAllSelected = _d[1];
    var _e = React.useState('IDLE'), fetchState = _e[0], setFetchState = _e[1];
    var _f = React.useState('IDLE'), bannerStatus = _f[0], setBannerStatus = _f[1];
    var _g = React.useState('IDLE'), bannerText = _g[0], setBannerText = _g[1];
    var _h = React.useState(false), showBanner = _h[0], setShowBanner = _h[1];
    React.useEffect(function () {
        if (root) {
            dispatchers.fetchFilesRequest(root, 'reliablePartner');
            var fields = (0, utils_1.mapSchema)(props.metaSchema, 'bid/tender/card/reliable/header');
            setColumns(fields);
        }
    }, [reliablePartnerReportStatus]);
    React.useEffect(function () {
        if (documents.length > 0) {
            var sortedSchema = columns.sort(function (a, b) { return a.order - b.order; });
            var updatedDocuments = (0, utils_2.updateDocumentMetaSchema)(sortedSchema, documents);
            var updatedItems = (0, fileListFilter_1.filterData)(sortedSchema, updatedDocuments, tenderActions.sortByOptions, tenderActions.searchOptions, sortedSchema);
            setItems(updatedItems);
        }
    }, [documents]);
    React.useEffect(function () {
        setAllSelected(items.length > 0 &&
            items.every(function (r) {
                return selectedDocuments.findIndex(function (document) {
                    return document.uuid === document.uuid;
                }) > -1;
            }));
    }, [selectedDocuments, items]);
    React.useEffect(function () {
        var isStatusChangedAndReportAvailable = function () {
            return reliablePartnerStatusCheck.isStatusChanged &&
                reliablePartnerReportStatus &&
                !['UNAVAILABLE', 'BUSINESS_ID_MISSING'].includes(reliablePartnerStatusCheck.value) &&
                reportParticipantUuid === props.participant.uuid;
        };
        if (reliablePartnerStatusFailure.error.type === 'THROTTLED_ERROR' ||
            !reliablePartnerStatusCheck.isStatusChanged ||
            isStatusChangedAndReportAvailable()) {
            setFetchState('FETCHED');
        }
    }, [
        reliablePartnerStatusFailure,
        reliablePartnerStatusCheck.value,
        reliablePartnerReportStatus,
        reliablePartnerStatusCheck.isStatusChanged
    ]);
    (0, useStatusEffect_1.useStatusEffect)({
        fetchState: fetchState,
        reliablePartnerStatusCheck: reliablePartnerStatusCheck,
        reliablePartnerReportStatus: reliablePartnerReportStatus,
        reliablePartnerStatusFailure: reliablePartnerStatusFailure,
        reliablePartnerFetchStatus: reliablePartnerFetchStatus,
        setBannerStatus: setBannerStatus,
        setFetchState: setFetchState,
        setBannerText: setBannerText,
        setShowBanner: setShowBanner
    });
    var getLatestReport = function (event) {
        event.preventDefault();
        setFetchState('FETCHING');
        dispatchers.fetchLatestReport(props.currentBid, props.participant);
        setFetchState('FETCHED');
    };
    return (React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-handshake' }), title: (0, translation_1.getLocalization)('bid/tenders/card/reliablePartner/title'), className: "tender-card-documents reliablePartner" },
        props.participant && documents.length > 0 && (React.createElement(RevisionModal_1.RevisionModal, { metaSchema: props.metaSchema, baseUrl: props.baseUrl, closeModal: tenderActionsDispatch.toggleRevisionModal, revisionFileUuid: documents[0].fileUuid || '' })),
        React.createElement("div", { className: 'bid-tender-documents-container' },
            React.createElement("div", { className: 'fetch-report' },
                documents.length > 0 && (React.createElement(sok_ui_1.Button, { size: 'medium', color: 'blue', iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-history' }), onClick: tenderActionsDispatch.toggleRevisionModal }, (0, translation_1.getLocalization)('bid/tenders/card/reliablePartner/revisionModal/button'))),
                React.createElement(SpinnerButton_1.SpinnerButton, { isButtonDisabled: props.currentBid.status === 'DRAFT_BID', iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-reply' }), className: 'fetch-button', color: 'green', shouldDisplaySpinner: fetchState === 'FETCHING', buttonText: (0, translation_1.getLocalization)('bid/tenders/card/reliablePartner/button'), handleOnClick: getLatestReport })),
            showBanner && (React.createElement("div", { className: "bid-banner-wrapper" },
                React.createElement(Banner_1.Banner, { setShowBanner: setShowBanner, notificationType: bannerStatus, bannerText: (0, translation_1.getLocalization)("bid/tenders/card/reliablePartner/banner/".concat(bannerText !== null && bannerText !== void 0 ? bannerText : bannerStatus)) }))),
            root && documents.length > 0 && (React.createElement("div", { className: classNames('file-list-wrapper', 'reliablePartner'), style: {
                    minHeight: Math.min(items.length + 1, 10) * 50 + 20,
                    marginBottom: '1rem'
                } },
                React.createElement(FileList_1.FileList, { key: 'list', isMobile: isMobile, currentFolder: root, items: items, sortByOptions: tenderActions.sortByOptions, searchOptions: tenderActions.searchOptions, convert: function () { return false; }, downloadFolder: dispatchers.downloadFolder(currentUser.token), isAllBookmarked: false, onBookmarkClick: function () { return false; }, onUnBookmarkClick: function () { return false; }, onBookmarkAllFiles: function () { return false; }, staticIconCount: 4, staticIconCountMobile: 3, toggleItem: function (item) {
                        return dispatchers.toggleDocuments([item], !selectedDocuments.find(function (document) {
                            return document.id === item.id;
                        }));
                    }, onSelectAll: function () {
                        return dispatchers.toggleDocuments(items, !allSelected);
                    }, itemSelections: selectedDocuments, isAllFollowed: false, sortBy: function (sortBy, order) { return 'desc'; }, isAllSelected: true, baseUrl: props.baseUrl, metaDataColumns: columns, onSetColumnFilter: function () { return false; }, navigateTo: function () { return false; }, openNotificationsMenu: function () { return false; }, token: currentUser.token, ListHeader: ListHeader_1.ListHeader, ListRow: (0, ListRow_1.ListRow)('reliablePartner'), parentClass: 'reliablePartner' }))),
            root && documents.length === 0 && (React.createElement(EmptyContent_1.EmptyContent, { root: root, section: 'reliablePartner' })))));
};
exports.default = ReliablePartner;
